import React, { useState, useEffect } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNodeId } from '@xyflow/react';

// Funções
import { useNodeUpdate } from '~/hooks/useNodeUpdate';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de espera
// Este componente permite que o usuário defina um tempo de espera em segundos antes de continuar a execução do fluxo
export const EsperarNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();
    const [inputValue, setInputValue] = useState(data.inputValue || '');
    
    // sync local state on undo/redo
    useEffect(() => { setInputValue(data.inputValue || ''); }, [data.inputValue]);
    
    const [listaPendencias, setListaPendencias] = useState([]);
    const conferePendencias = () => {
        const pendencias = [];
        if (!inputValue || isNaN(inputValue) || parseFloat(inputValue) <= 0) {
            pendencias.push("Tempo deve ser um número positivo");
        }
        setListaPendencias(pendencias);
        return pendencias;
    };
    
    const handleChange = (e) => {
        const v = e.target.value;
        setInputValue(v);
        onNodesChange([{ id, type: 'update', data: { inputValue: v } }]);
    };

    useEffect(() => { conferePendencias(); }, [inputValue]);

    return (
        <div className="node node-esperar">
            <div className="titulo-node"><FontAwesomeIcon icon="fa-solid fa-clock" />{data.label.toUpperCase()}</div>
            <div className="linha-separadora" />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert("Executar")}><FontAwesomeIcon icon="fa-solid fa-circle-play" /></button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal">
                    <div className="body-node"></div>
                    <span className="icon">Tempo de espera:</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "8px" }}>
                        <input 
                            type="number" 
                            value={inputValue} 
                            onChange={handleChange}
                            placeholder="0"
                            min="0"
                            step="0.1"
                            style={{
                                padding: "8px 12px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "14px",
                                width: "100px"
                            }}
                        />
                        <span style={{ fontSize: "14px", color: "#666" }}>segundos</span>
                    </div>
                    <CustomHandle type="target" position="top" connectionCount={1} allowLoopConnections={true} />
                    <CustomHandle type="source" position="bottom" connectionCount={1} />
                </div>
            </div>
        </div>
    );
};
